/** Identidade de movimento do produto ("Evolucao Disciplinada"): uma curva
 * de easing unica, dois ritmos — 180ms pra entradas/saidas de UI (drawer,
 * modal, toast), 360ms pra "assentamentos" (drop no kanban, confirmacoes).
 * Espelha as variaveis CSS --ease-product/--dur-snap/--dur-settle em
 * styles/tokens.css, na forma que o Framer Motion espera (numero em
 * segundos, array de 4 pontos pra curva). Mantenha os dois em sincronia se
 * algum dia mudar. */
export const EASE_PRODUCT = [0.22, 1, 0.36, 1] as const;
export const DUR_SNAP = 0.18;
export const DUR_SETTLE = 0.36;
